import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "btn btn-link p-0 mb-1 mx-1",
  title: "Français"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "locale-flag",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#ed2939",
    d: "M36 27c0 2.209-1.791 4-4 4h-8V5h8c2.209 0 4 1.791 4 4v18z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#002495",
    d: "M4 5C1.791 5 0 6.791 0 9v18c0 2.209 1.791 4 4 4h8V5H4z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#eee",
    d: "M12 5h12v26H12z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_3))
}